import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-list-header-admin',
  templateUrl: './menu-list-header-admin.component.html',
  styleUrl: './menu-list-header-admin.component.scss'
})
export class MenuListHeaderAdminComponent {

}
